import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.primary_100};
      border-radius: ${theme.radius.sm};
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      flex-shrink: 0;
      flex-grow: 1;
    `;
  }};
`;
